import { render, staticRenderFns } from "./CompPeopleTourRewardCard.vue?vue&type=template&id=611e4118"
import script from "./CompPeopleTourRewardCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompPeopleTourRewardCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports